<!-- 网站首页 -->
<template>
  <div>
    <!-- pc -->
    <div @click="isshow=true" class="cards hidden-xs hidden-sm hidden-md">
      <el-image :z-index="indexn" style="width: 440px; height: 250px;border-radius: 10px;"
        :src="get_listurl"></el-image>
      <!-- 数量 -->
      <span class="cards_n color_ffffff font_12 border_radius6">{{get_peoplenumber}}</span>
      <span class="cards_n2 color_ffffff font_12">NO.{{ obj.productNum }}</span>
    </div>
    <!-- h5 -->
    <div @click="isshow=true" class="cards_h5 hidden-lg">
      <el-image :z-index="indexn" style="width: 315px; height: 180px;border-radius: 10px;"
        :src="get_listurl"></el-image>
      <!-- 数量 -->
      <span class="cards_n_h5 color_ffffff font_9 border_radius6">{{get_peoplenumber }}</span>
      <span class="cards_n2_h5 color_ffffff font_12">NO.{{ obj.productNum }}</span>
    </div>
    <transition name="el-fade-in-linear"><public-downloadCard :productNum='obj.productNum' :bigUrl='get_bigurl'
        v-if="isshow" @callback='isshow=false'></public-downloadCard></transition>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  export default {
    data() {
      return {
        isshow: false
      };
    },
    props: {
      obj: {
        type: Object
      },
      list: {
        type: Array
      },
      indexn: {
        type: Number
      }
    },
    computed: {
      ...mapGetters('setting', ['GET_LANG2']),
      get_listurl() {
        if (this.GET_LANG2 === 'cn') {
          return this.obj.listUrl;
        } else if (this.GET_LANG2 === 'en') {
          return this.obj.listUrlEn;
        } else if (this.GET_LANG2 === 'jp') {
          return this.obj.listUrlJp;
        }
      },
      get_bigurl() {
        if (this.GET_LANG2 === 'cn') {
          return this.obj.bigUrl;
        } else if (this.GET_LANG2 === 'en') {
          return this.obj.bigUrlEn;
        } else if (this.GET_LANG2 === 'jp') {
          return this.obj.bigUrlJp;
        }
      },
      get_peoplenumber() {
        if (this.GET_LANG2 === 'cn') {
          return `已有${this.obj.hasCount}人拥有`;
        } else if (this.GET_LANG2 === 'en') {
          return `${this.obj.hasCount} already own`;
        } else if (this.GET_LANG2 === 'jp') {
          return `日本では既に${this.obj.hasCount}人が入手した`;
        }
      }
    },
    methods: {

    }
  };
</script>

<style scoped="scoped">
  .cards {
    position: relative;
  }

  .cards_n {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 24px;
    line-height: 24px;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 0 10px;
  }

  .cards_n2 {
    position: absolute;
    bottom: 12px;
    left: 15px;
  }

  .cards_h5 {
    position: relative;
    width: 315px;
    height: 180px;
  }

  .cards_n_h5 {
    position: absolute;
    top: 15px;
    right: 15px;
    height: 18px;
    line-height: 18px;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 0 10px;
  }

  .cards_n2_h5 {
    position: absolute;
    bottom: 10px;
    left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-cards/public-cards.vue